import apisauce from 'apisauce'
import Config from 'APP/Config'

export interface ConsentFormVersions {
  [brandId: string]: {
    [region: string]: {
      [languageCode: string]: {
        [type: string]: {
          version: string
          file_path: string
        }
      }
    }
  }
}

const create = (baseURL: string = `${Config.ASSETS_DOMAIN}`) => {
  const api = apisauce.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  })

  const getConsentFormRegion = () => {
    // This is a temporary solution to get the assets region, because the assets identifies the eu region as uk
    return Config.REGION === 'EU' ? 'UK' : Config.REGION
  }

  const getConsentFormVersions = async () => {
    const response = await api.get<ConsentFormVersions>('/consent-forms/consent_forms.json')

    return response.ok ? response.data : null
  }

  const getConsentFormVersion = async (
    brandId: string,
    region: string,
    languageCode: string,
    type: string
  ): Promise<string | null> => {
    const regionLowerCase = region.toLowerCase()

    const versions = await getConsentFormVersions()

    const versionData = versions?.[brandId]?.[regionLowerCase]?.[languageCode]?.[type]

    if (versionData && versionData.version) {
      return versionData.version as string
    }

    return null
  }

  return {
    getConsentFormRegion,
    getConsentFormVersions,
    getConsentFormVersion,
  }
}

export default {
  create,
}
